import React from 'react'
import classes from './FormattedDate.css'
import moment from 'moment'

import { getDateFormat, getTimeFormat } from '../../constants'

export const FormattedDate = props => {
  const {
    fmt,
    date,
    id,
    overrideSameDay,
    overrideLastDay,
    todayFmt,
    yesterdayFmt,
    me,
  } = props

  const getDate = d => {
    if (!d) {
      return '-'
    }

    const defaultFmt = `${getDateFormat(me)} [at] ${getTimeFormat(me)}`
    const displayFormat = fmt || defaultFmt
    let sameDayFmt
    let lastDayFmt

    if (overrideSameDay) {
      sameDayFmt = displayFormat
    } else {
      sameDayFmt = todayFmt || `[Today at] ${getTimeFormat(me)}`
    }

    if (overrideLastDay) {
      lastDayFmt = displayFormat
    } else {
      lastDayFmt = yesterdayFmt || `[Yesterday at] ${getTimeFormat(me)}`
    }

    return moment(d).calendar(null, {
      sameDay: sameDayFmt,
      nextDay: displayFormat,
      nextWeek: displayFormat,
      lastDay: lastDayFmt,
      lastWeek: displayFormat,
      sameElse: displayFormat,
    })
  }

  return (
    <span id={id}>
      {getDate(date)}
    </span>
  )
}

export default FormattedDate



// WEBPACK FOOTER //
// ./src/legacy/components/FormattedDate/FormattedDate.jsx